var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.label}},[_c('b-form-timepicker')],1):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('time-picker-v1-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(
      _vm.showType == 'form-submitter' ||
        (_vm.showType == 'e-form' && _vm.properties.eFormEditable)
    )?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.computedConditions.description
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: _vm.properties.description,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.description,"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label,"hidden":_vm.computedHidden,"state":_vm.state,"invalid-feedback":_vm.errors.join(', ')}},[_c('b-form-timepicker',{staticStyle:{"font-size":"14px"},attrs:{"readonly":_vm.computedConditions.readonly
          ? _vm.superComputeFormSubmitterValue({
              elementId: this.id,
              property: 'readonly',
              value: _vm.properties.readonly,
              defaultValue: false,
              form: this.form
            })
          : _vm.properties.readonly,"state":_vm.state,"popper-opts":{
        positionFixed: true
      }},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}})],1):_vm._e(),(
      _vm.showType == 'form-viewer' ||
        (_vm.showType == 'e-form' && !_vm.properties.eFormEditable)
    )?_c('b-form-group',{attrs:{"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label}},[_vm._v(" "+_vm._s(_vm.controlValue)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }